import { Button } from "../Forms/Forms";
import './mobileStickyBlock.scss'
import { priceFormat } from "../../helpers/helpers";
import { useSelector } from "react-redux";

const MobileStickyBlock = (props) => {
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    return (
        <div className='sticky-block'>
            <div className='total-price-block' >
                <div className='price-block'>
                    <span className='price-label'>{props.labels[0]}</span>
                    {props.selectedOperations.length < 1 ? <span className='no-price'>{props.labels[1]}</span>
                        : <div> <span className='price'>{priceFormat(props.totalPrice)}</span> <span>{props.labels[2]} </span></div>}
                </div>
                <div className='cta-block'>
                    <Button isDisabled={selectedForfaitFromStore.length < 1}
                        handlClick={props.handleFirstButton}
                    >
                        {props.labels[3]}
                    </Button>
                    <Button isDisabled={selectedForfaitFromStore.length < 1}
                        handlClick={props.handleSeconButton}
                    >
                        {props.labels[4]}
                    </Button>

                </div>

            </div>
            <Button isDisabled={selectedForfaitFromStore.length < 1}
                handlClick={props.handleThirdButton}
            >
                {props.labels[5]}
            </Button>
        </div>
    );
}
export default MobileStickyBlock;